import { createSelector } from 'reselect';

const selectEditQuestion = state => state.editQuestionPage;

export const selectEditQuestionPageState = createSelector(
    [selectEditQuestion],
    editQuestionPage => editQuestionPage.editQuestionHidden
);
